import login_pt from './locales/pt/login.json';
import login_es from './locales/es/login.json';
import global_errors_pt from './locales/pt/global_errors.json';
import global_errors_es from './locales/es/global_errors.json';
import common_pt from './locales/pt/common.json';
import common_es from './locales/es/common.json';
import menu_pt from './locales/pt/menu.json';
import menu_es from './locales/es/menu.json';
import instrutor_pt from './locales/pt/instrutor.json';
import instrutor_es from './locales/es/instrutor.json';
import trilhas_pt from './locales/pt/trilhas.json';
import trilhas_es from './locales/es/trilhas.json';
import webinars_pt from './locales/pt/webinars.json';
import webinars_es from './locales/es/webinars.json';
import materiais_pt from './locales/pt/materiais.json';
import materiais_es from './locales/es/materiais.json';
import gestao_aulas_pt from './locales/pt/gestao_de_aulas.json';
import gestao_aulas_es from './locales/es/gestao_de_aulas.json';
import material_de_apoio_pt from './locales/pt/materiais_de_apoio.json';
import material_de_apoio_es from './locales/es/materiais_de_apoio.json';
import ferramentas_pt from './locales/pt/ferramentas.json';
import ferramentas_es from './locales/es/ferramentas.json';
import profile_pt from './locales/pt/profile.json';
import profile_es from './locales/es/profile.json';

const resources = {
	pt: {
		common: common_pt,
		login: login_pt,
		global_errors: global_errors_pt,
		menu: menu_pt,
		instrutor: instrutor_pt,
		trilhas: trilhas_pt,
		webinars: webinars_pt,
		materiais: materiais_pt,
		gestao_de_aulas: gestao_aulas_pt,
		materiais_de_apoio: material_de_apoio_pt,
		ferramentas: ferramentas_pt,
		profile: profile_pt
	},
	es: {
		common: common_es,
		login: login_es,
		global_errors: global_errors_es,
		menu: menu_es,
		instrutor: instrutor_es,
	  trilhas: trilhas_es,
		webinars: webinars_es,
		materiais: materiais_es,
		gestao_de_aulas: gestao_aulas_es,
		materiais_de_apoio: material_de_apoio_es,
		ferramentas: ferramentas_es,
		profile: profile_es
	}
};

export default resources;
